import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "col-4" }, "Thông tin vật tư", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Tên:", -1)
const _hoisted_3 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_4 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Số lượng trong biên bản:", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Số lượng đã xuất:", -1)
const _hoisted_9 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_10 = { class: "row mt-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Số lượng còn thiếu:", -1)
const _hoisted_12 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Đơn vị tính:", -1)
const _hoisted_14 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted break-word" }, "Tổng giá trị vật tư đã xuất từ các kho:", -1)
const _hoisted_16 = { class: "fw-bolder fs-6 text-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isDisplay,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDisplay) = $event)),
    title: _ctx.titleComputed,
    "before-close": _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        "empty-text": "Vật tư này chưa được xuất ở bất cứ kho nào",
        data: _ctx.supplyGettingData.kho_arr,
        border: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "ID",
            property: "kho_id"
          }),
          _createVNode(_component_el_table_column, {
            label: "Tên kho",
            property: "ten_kho"
          }),
          _createVNode(_component_el_table_column, {
            label: "Tổng số trong kho",
            property: "tong_so_trong_kho"
          }),
          _createVNode(_component_el_table_column, {
            label: "Đã lấy trong kho",
            property: "da_lay"
          }),
          _createVNode(_component_el_table_column, { label: "Còn lại trong kho" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.con_lai.toFixed(2)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_DivCol, { cols: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.supplyData.ten_vat_tu), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _createVNode(_component_DivCol, { cols: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                default: _withCtx(() => [
                  _createTextVNode("Đơn giá:")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DivCol, { cols: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formatCurrencyAndQuantity(_ctx.supplyData.don_gia)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.supplyGettingData.so_luong_can), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createVNode(_component_DivCol, { cols: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.supplyGettingData.so_luong_can - _ctx.supplyGettingData.con_thieu), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_DivCol, { cols: 8 }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.supplyGettingData.con_thieu), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_13,
          _createVNode(_component_DivCol, { cols: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.supplyData.don_vi_tinh ? _ctx.supplyData.don_vi_tinh : "-"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DivRow, { class: "mt-5" }, {
        default: _withCtx(() => [
          _hoisted_15,
          _createVNode(_component_DivCol, { cols: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.totalPriceOutput), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"]))
}